// extracted by mini-css-extract-plugin
module.exports = {"forumPosts":"styles-module__forumPosts___eEqfP"};